import $ from 'jquery';
import Shuffle from 'shufflejs';
import 'imagesloaded';
import throttle from 'lodash/throttle';

let hasLoaded = false;

$(window).load(() => {
  if (window.matchMedia('(max-width: 1200px)').matches || !$('.js-grid-item').length) {
    $('.js-gradient-overlay').hide();
    return;
  }

  window.addEventListener('resize', throttle(initialiseGrid, 200));

  $('.js-gallery-container').imagesLoaded(initialiseGrid);
});

function initialiseGrid() {
  if (hasLoaded) {
    return;
  }

  hasLoaded = true;
  /* eslint-disable */
  const shuffleInstance = new Shuffle($('.js-gallery-container'), {
    itemSelector: '.js-grid-item',
    sizer: '.js-gutter',
    columnWidth: 150,
  });

  shuffleInstance.sort({
    randomize: true,
  });
  /* eslint-enable */

  window.setInterval(animateRandomImage, 500);
}

function animateRandomImage() {
  const images = $('.js-grid-item');
  const image = getRandomItem(images);
  let image2 = {};

  // Find another image with the same width
  // 500 is just so we don't have to loop forever and it'll run back into here on the next interval anyway
  for (let i = 0; i <= 500; i += 1) {
    const newRandom = getRandomItem(images);
    if (image.outerWidth() === newRandom.outerWidth() && image.outerHeight() === newRandom.outerHeight()) {
      const url1 = image.find('img')[0].src;
      const url2 = newRandom.find('img')[0].src;

      if (url1 !== url2) {
        image2 = newRandom;
        break;
      }
    }
  }


  image.addClass('fade-out');
  image2.addClass('fade-out');

  setTimeout(() => {
    const src1 = image.find('img')[0].src;
    const src2 = image2.find('img')[0].src;

    image.find('img')[0].src = src2;
    image2.find('img')[0].src = src1;

    image2.removeClass('fade-out');
    image.removeClass('fade-out');
  }, 3000);
}

function getRandomItem(array) {
  let toReturn = {};

  for (let i = 0; i <= array.length; i += 1) {
    toReturn = $(array[Math.floor(Math.random() * array.length)]);

    if (!toReturn.hasClass('fade-out')) {
      return toReturn;
    }
  }

  return $(array[Math.floor(Math.random() * array.length)]);
}
